import React from 'react';

import type { ThemeData, ThemeStrategyArgs, ThemeStrategyResult } from './../../ricos-types';

import createCustomStyles from './generators/customStyles';
import createPalette from './generators/palette';
import createTypography from './generators/typography';
import * as utils from './themeUtils';

// TODO: remove in v11
// @deprecated
export default function themeStrategy(args: ThemeStrategyArgs): ThemeStrategyResult {
  const { buildCssVars } = utils;
  const { ricosTheme = {} } = args;
  const {
    parentClass = '',
    palette,
    paletteConfig,
    typography,
    customStyles,
    settingsStyles,
    nativeStyle,
  } = ricosTheme;

  // Create CSS Vars
  const { paletteVarsObject, colors } = createPalette(palette, paletteConfig);
  const typographyVarsObject = createTypography(typography);
  const customsVarsObject = createCustomStyles({
    customStyles,
    settingsStyles,
    nativeStyle,
  });

  const themeData: ThemeData = {
    colors,
    utils,
    customStyles,
  };

  const html = (
    <style type="text/css" key={'styleElement'}>
      {buildCssVars(parentClass, paletteVarsObject, typographyVarsObject, customsVarsObject)}
    </style>
  );

  return {
    html,
    themeData,
  };
}
